import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { ResponseTrailerTypeContract } from '~lmo/models/trailerTypeContract.model';
import { TruckingVendorContract } from '~lmo/models/trucking-vendor.model';
import { LmoFracsService, LmoTrailerTypeContractService, LmoTruckingVendorsService } from '~lmo/services';
import { TrailerType } from '~v2Models/well.model';

@Component({
  selector: 'sa-lmo-frac-fctv-trailer-type-contract-edit',
  styleUrls: ['./lmo-frac-fctv-trailer-type-contract-edit.component.scss'],
  templateUrl: './lmo-frac-fctv-trailer-type-contract-edit.component.html',
})
export class LmoFracFctvTrailerTypeContractEditComponent implements OnInit {
  public newTrailerTypeContractForm: FormGroup;
  public trailerTypes$: Observable<TrailerType[]>;
  public vendorContracts$: Observable<TruckingVendorContract[]>;
  public activeNetworkRequest$ = new BehaviorSubject<boolean>(false);

  public get formValue(): ResponseTrailerTypeContract {
    return this.newTrailerTypeContractForm.value;
  }

  constructor(
    private fb: FormBuilder,
    private fracService: LmoFracsService,
    private truckingVendorService: LmoTruckingVendorsService,
    private trailerTypeContractService: LmoTrailerTypeContractService,
    private matDialogRef: MatDialogRef<LmoFracFctvTrailerTypeContractEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ResponseTrailerTypeContract,
  ) {}

  public ngOnInit() {
    this.newTrailerTypeContractForm = this.fb.group({
      fracClusterTruckingVendorId: [this.data.fracClusterTruckingVendorId, [Validators.required]],
      id: [this.data.id, [Validators.required]],
      trailerTypeId: [this.data.trailerTypeId, [Validators.required]],
      vendorContractId: [this.data.vendorContractId, [Validators.required]],
    });
    this.trailerTypes$ = this.fracService.trailerTypes$;
    this.vendorContracts$ = this.truckingVendorService.vendorContracts$;
  }

  public close() {
    this.matDialogRef.close();
  }

  public patchTrailerTypeContract() {
    if (this.newTrailerTypeContractForm.invalid) {
      return;
    }
    const request = this.formValue;
    this.activeNetworkRequest$.next(true);
    this.trailerTypeContractService.updateTrailerTypeContract$(request).subscribe(async (success) => {
      this.activeNetworkRequest$.next(false);
      if (success) {
        this.matDialogRef.close(true);
      }
    });
  }

  public trackByTrailerType(index: number, item: TrailerType): number {
    return item.id;
  }

  public trackByVendorContract(index: number, item: TruckingVendorContract): number {
    return item.id;
  }
}
